<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>Payments for Order No. {{ salesOrderNo }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-list three-line fill-height v-if="items.length > 0">
        <template
          v-for="(item, index) in items"
        >
          <v-list-tile
            :key="item.id"
            avatar
            ripple
          >
            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-icon v-if="item.status === 'confirmed'" medium color="green">check_circle_outline</v-icon>
                <v-icon v-else-if="item.status === 'pending'" medium color="white">hourglass_empty</v-icon>
                <v-icon v-else color="red" medium>priority_high</v-icon>
              </v-list-tile-action-text>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>
                <router-link class="font-weight-bold orange--text text--lighten-2" :to="'/payment/' + item.paymentId">
                  {{ item.paymentMethodName + ' ' + item.currencySign + formatPrice(item.amount, item.currencyDecimals, item.currencyDecimalSign) }} <span v-if="item.currencyCode !== salesOrder.currencyCode" class="grey--text caption font-weight-bold ml-2">({{ salesOrder.currencySign + formatPrice(item.amountInBase / salesOrder.exchangeRateToBase, salesOrder.currencyDecimals, salesOrder.currencyDecimalSign) }})</span>
                </router-link>
                <span v-if="item.feeAmount && item.feeAmount > 0" class="grey--text body-1 ml-2">(+fee {{ item.currencySign + formatPrice(item.feeAmount, item.currencyDecimals, item.currencyDecimalSign) }})</span>
                <span class="caption ml-2">{{ item.createdDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</span>
              </v-list-tile-title>
              <v-list-tile-sub-title class="caption">
                {{ item.desc }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title class="text--primary">
                <v-btn outline small class="caption ml-1 mr-1 mt-1 mb-1" v-if="isAccessDeletePayment" @click="deletePayment(item.paymentId)">DELETE</v-btn>
                <v-btn outline small class="caption ml-1 mr-1 mt-1 mb-1" v-if="isAccessConfirmPayment && item.status !== 'confirmed'" @click="acceptPayment(item.paymentId)">CONFIRM</v-btn>
                <v-btn outline small class="caption ml-1 mr-1 mt-1 mb-1" v-if="isAccessConfirmPayment && item.status === 'confirmed'" @click="cancelPayment(item.paymentId)">CANCEL</v-btn>
                <v-btn outline small class="caption ml-1 mr-1 mt-1 mb-1" v-if="isAccessConfirmPayment && item.status === 'confirmed'" @click="chargebackPayment(item.paymentId)">Chargeback</v-btn>
                <div class="caption ml-2">{{ item.status | capitalize }} <span v-if="item.status === 'confirmed'">on {{ item.confirmationDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</span></div>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <div class="mr-3" v-if="isAccessCosting && (item.paymentMethodId !== 'BALANCE' && item.paymentMethodId !== 'CREDIT' && item.paymentMethodId !== 'CASH' && item.receivedOnBehalfBySellerUserId === '')">
              <v-container fluid grid-list-lg class="pa-0" style="max-width:450px;">
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-select
                      v-model="item.realFeeCurrencyCode"
                      v-bind:items="currencies"
                      item-text="sign"
                      item-value="currencyCode"
                      label="Currency"
                      hide-details
                      @change="item.realFeeExchangeRateToBase = getRateToBase(item.realFeeCurrencyCode); item.saveButtonStatus = '';"
                    ></v-select>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      v-model="item.realFeeAmount"
                      label="Real Transaction Fee"
                      hide-details
                      @keyup="item.saveButtonStatus = ''"
                    ></v-text-field>
                    <div v-if="item.realFeeCurrencyCode !== def.currency.currencyCode && item.realFeeAmount > 0 && item.realFeeExchangeRateToBase > 0" class="caption font-weight-light grey--text">{{ def.currency.sign }}{{ formatPrice(item.realFeeAmount * item.realFeeExchangeRateToBase, def.currency.decimals, def.currency.decimalSign) }}</div>
                  </v-flex>
                  <v-flex xs5>
                    <v-text-field
                      v-model="item.realFeeExchangeRateToBase"
                      label="Rate to USD"
                      hide-details
                      @keyup="item.saveButtonStatus = ''"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
              <span v-if="item.realFeeUpdatedDateTime" class="caption grey--text">
                Updated {{ item.realFeeUpdatedDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}
                <span v-if="item.realFeeUpdatedByAdminName">by {{ item.realFeeUpdatedByAdminName }}</span>
              </span>
            </div>

            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-btn
                  v-if="isAccessCosting && (item.paymentMethodId !== 'BALANCE' && item.paymentMethodId !== 'CREDIT' && item.paymentMethodId !== 'CASH')"
                  @click="saveRealFee(item)"
                  outline
                  :disabled="!(item.realFeeCurrencyCode !== '' && item.realFeeAmount >= 0 && item.realFeeExchangeRateToBase > 0) || item.saveButtonStatus === 'disabled'"
                >
                  <v-progress-circular
                    v-if="item.saveButtonStatus === 'saving'"
                    indeterminate
                    small
                    color="primary"
                    :width=3
                    class="ma-3"
                    dark
                  ></v-progress-circular>
                  <span v-else-if="item.saveButtonStatus === 'success'">
                    <v-icon medium color="green">check_circle_outline</v-icon>
                  </span>
                  <span v-else>
                    Save
                  </span>
                </v-btn>
              </v-list-tile-action-text>
            </v-list-tile-action>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No payment yet
            </div>
          </v-flex>
        </template>

      </v-list>
      <v-fab-transition v-if="isAccessCreatePayment">
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          :to="'/order/' + salesOrderNo + '/payment'"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
  .media {
    height: 100%;
    margin: 0;
  }

  table.v-table tbody td:first-child {
    padding: 15px 15px;
  }

  .item-name {
    padding: 5px !important;
  }

  .item-thumb {
    width: 60px;
    height: auto;
  }
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  props: [
    'salesOrderNo'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      salesOrder: {},
      items: [],
      currencies: [],
      isAccessCosting: false,
      isAccessCreatePayment: false,
      isAccessUpdatePayment: false,
      isAccessDeletePayment: false,
      isAccessConfirmPayment: false
    }
  },
  mounted () {
    this.openDrawerForDesktop()
    this.listPayments()
    this.getCurrencies()

    if (typeof this.profile.permissions !== 'undefined') {
      for (var i in this.profile.permissions) {
        if (this.profile.permissions[i].permissionId === 'PEM-COSTING' && this.profile.permissions[i].isRead === '1') {
          this.isAccessCosting = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-PAYMENT' && this.profile.permissions[i].isCreate === '1') {
          this.isAccessCreatePayment = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-PAYMENT' && this.profile.permissions[i].isUpdate === '1') {
          this.isAccessUpdatePayment = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-PAYMENT' && this.profile.permissions[i].isDelete === '1') {
          this.isAccessDeletePayment = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-PAYMENT' && this.profile.permissions[i].isConfirm === '1') {
          this.isAccessConfirmPayment = true
        }
      }
    }
  },
  methods: {
    getRateToBase: function (currencyCode) {
      for (var i in this.currencies) {
        if (this.currencies[i].currencyCode === currencyCode) {
          return this.currencies[i].exchangeRateToBase
        }
      }
      return 0
    },
    getCurrencies: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/currencies')
        .then(resp => {
          console.log(resp.data)
          _this.loading = false
          if (resp.data.status === 'success') {
            for (var i in resp.data.data) {
              if (resp.data.data[i].currencyCode === _this.currencyCode) {
                resp.data.data[i].exchangeRateToBase = _this.exchangeRateToBase
              }
            }
            _this.currencies = resp.data.data
          } else {
            console.log('unable to load currencies: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    listPayments: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo)
        .then(resp => {
          _this.loading = false
          if (resp.data.status === 'success') {
            _this.items = []
            for (var c = 0; c < resp.data.data.payments.length; ++c) {
              if (resp.data.data.payments[c].paymentMethodId.substr(0, 12) === 'BANKTRANSFER') {
                resp.data.data.payments[c].desc = resp.data.data.payments[c].ttDestinationBankName + ' - ' + resp.data.data.payments[c].ttDestinationBankAccountNo + ' - ' + resp.data.data.payments[c].ttDestinationBankAccountName
              } else if (resp.data.data.payments[c].paymentMethodId === 'CASH') {
                resp.data.data.payments[c].desc = 'Received by ' + resp.data.data.payments[c].cashReceivedBy
              }

              // button statuses: '', disabled, saving
              resp.data.data.payments[c].saveButtonStatus = 'disabled'
            }
            _this.items = resp.data.data.payments
            _this.salesOrder = resp.data.data
          } else {
            console.log('unable to load sales order payments: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    },
    acceptPayment: function (paymentId) {
      this.loading = true
      var _this = this
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/payment/' + paymentId, {
        status: 'confirmed'
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          if (resp.data.status === 'success') {
            _this.loading = false
            _this.listPayments()
            window.alert('Payment confirmed')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
            _this.loading = false
          }
        })
    },
    cancelPayment: function (paymentId) {
      this.loading = true
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/payment/' + paymentId, {
        status: 'pending'
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          if (resp.data.status === 'success') {
            this.loading = false
            this.listPayments()
            window.alert('Payment canceled')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    deletePayment: function (paymentId) {
      var action = window.confirm('Are you sure to delete this payment?')
      if (action) {
        this.loading = true
        axios.delete(process.env.VUE_APP_API_ROOT + '/v1/payment/' + paymentId)
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.listPayments()
            } else {
              window.alert(resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    chargebackPayment: function (paymentId) {
      this.loading = true
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/payment/' + paymentId, {
        status: 'chargeback'
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(resp => {
          if (resp.data.status === 'success') {
            this.loading = false
            this.listPayments()
            window.alert('Payment set as chargeback')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    saveRealFee (item) {
      var _this = this
      item.saveButtonStatus = 'saving'
      axios.put(process.env.VUE_APP_API_ROOT + '/v1/costing/payment/' + item.paymentId, {
        currencyCode: item.realFeeCurrencyCode,
        exchangeRateToBase: item.realFeeExchangeRateToBase,
        realFeeAmount: item.realFeeAmount
      })
        .then(resp => {
          if (resp.data.status === 'success') {
            item.saveButtonStatus = 'success'
            setTimeout(function () {
              item.saveButtonStatus = 'disabled'
            }, (5 * 1000))
          } else {
            item.saveButtonStatus = ''
            window.alert('Unable to save real fee: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            item.saveButtonStatus = ''
          }
        })
    }

  }

}
</script>
